import React, { useEffect, useState } from "react";
import BaseLayout from "../../components/BaseLayout";
import HeaderBaseLayout from "../../components/HeaderBaseLayout";
import MonthPage from "./MonthPage";
import WeekPage from "./WeekPage";
import moment from "moment";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { dataHeader, allMonth } from "./data";
import { btnRange } from "../../utils/constant";
import { getYear, dateFormat, getWeek } from "../../utils/utilities";
import { connect } from "react-redux";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import "./style.scss";

const Calendar = (p) => {
  const {
    listEventsMonthly,
    listAppointmentsMonthly,
    listGreetingsMonthly,
    listAll,
  } = p;
  const navigate = useNavigate();
  const yearNow = getYear(moment().toDate());
  const monthNow = moment().toDate().getMonth();
  const dateNow = dateFormat(moment().toDate());
  const [activeNav, setActiveNav] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [activeDay, setActiveDay] = useState(dateFormat(moment().toDate()));
  const [activeMonth, setActiveMonth] = useState(moment().toDate().getMonth());
  const [listAllDataWeekly, setListAllDataWeekly] = useState([]);
  const [listEventsWeekly, setListEventsWeekly] = useState([]);
  const [listAppointmentsWeekly, setListAppointmentsWeekly] = useState([]);
  const [listGreetingsWeekly, setListGreetingsWeekly] = useState([]);
  const [activeWeek, setActiveWeek] = useState(getWeek(moment().toDate()));
  const renderMonth =
    (activeMonth + 1).toString().length < 2
      ? "0" + (activeMonth + 1)
      : activeMonth + 1;
  const flexibleDate = `${yearNow}-${renderMonth}-${moment(activeDay).format(
    "DD"
  )}`;
  const [initialDataAllMonthly, setInitialDataAllMonthly] = useState([]);
  const [dataAllMonthly, setDataAllMonthly] = useState([]);
  const [initialDataEventsMonthly, setInitialDataEventsMonthly] = useState([]);
  const [dataEventsMonthly, setDataEventsMonthly] = useState([]);
  const [initialDataAppointmentsMonthly, setInitialDataAppointmentsMonthly] =
    useState([]);
  const [dataAppointmentsMonthly, setDataAppointmentsMonthly] = useState([]);
  const [initialDataGreetingsMonthly, setInitialDataGreetingsMonthly] =
    useState([]);
  const [dataGreetingsMonthly, setDataGreetingsMonthly] = useState([]);
  const [dataDaysInWeeks, setDataDaysInWeeks] = useState([]);

  const handleClickAddReminder = () => {
    navigate(PageRoutes.calendarAddReminder);
  };

  const params = {
    activeNav,
    setActiveNav,
    activeDay,
    dateNow,
    setActiveDay,
    activeMonth,
    setActiveMonth,
    monthNow,
    yearNow,
    listAllDataWeekly,
    listEventsMonthly,
    listEventsWeekly,
    listAppointmentsMonthly,
    listAppointmentsWeekly,
    listGreetingsMonthly,
    listGreetingsWeekly,
    flexibleDate,
    activeWeek,
    setActiveWeek,
    listAll,
    renderMonth,
    dataAllMonthly,
    setDataAllMonthly,
    dataEventsMonthly,
    setDataEventsMonthly,
    dataAppointmentsMonthly,
    setDataAppointmentsMonthly,
    dataGreetingsMonthly,
    setDataGreetingsMonthly,
    dataDaysInWeeks,
    setDataDaysInWeeks,
    activePage,
  };

  const getEventsMonthly = async () => {
    let { data, status } = await p.getListEventsMonthly(flexibleDate);
    if (status == 200) {
      setInitialDataEventsMonthly(data);
    }
  };

  const getAppointmentsMonthly = async () => {
    let { data, status } = await p.getListAppointmentsMonthly(flexibleDate);
    if (status == 200) {
      setInitialDataAppointmentsMonthly(data);
    }
  };

  const getGreetingsMonthly = async () => {
    let { data, status } = await p.getListGreetingsMonthly(flexibleDate);
    if (status == 200) {
      let updateKey = data.map((data) => ({
        id: data.id,
        day: data.day,
        month: data.month,
        start: data.date,
        type: data.type,
        thumbnail: data.thumbnail,
        user_first_name: data.user_first_name,
        user_last_name: data.user_last_name,
        user_email: data.user_email,
      }));
      let sortByAscDate = updateKey.sort(
        (a, b) => parseFloat(a.day) - parseFloat(b.day)
      );
      setInitialDataGreetingsMonthly(sortByAscDate);
    }
  };

  useEffect(() => {
    let mergeDataType = [
      ...initialDataEventsMonthly,
      ...initialDataAppointmentsMonthly,
      ...initialDataGreetingsMonthly,
    ];
    let sortByAscDate = mergeDataType.sort(
      (a, b) => moment(a.start).format("D") - moment(b.start).format("D")
    );
    setInitialDataAllMonthly(sortByAscDate);
    setDataAllMonthly(sortByAscDate);
  }, [
    initialDataGreetingsMonthly,
    initialDataAppointmentsMonthly,
    initialDataGreetingsMonthly,
  ]);

  useEffect(() => {
    getEventsMonthly();
    getAppointmentsMonthly();
    getGreetingsMonthly();
  }, [activeMonth]);

  useEffect(() => {
    let dataAllThisMonth = initialDataAllMonthly.filter(
      (a) => moment(a.start).format("YYYY-MM") == `${yearNow}-${renderMonth}`
    );
    setDataAllMonthly(dataAllThisMonth);

    let dataEventsThisMonth = initialDataEventsMonthly.filter(
      (a) => moment(a.start).format("YYYY-MM") == `${yearNow}-${renderMonth}`
    );
    setDataEventsMonthly(dataEventsThisMonth);

    let dataAppointmentsThisMonth = initialDataAppointmentsMonthly.filter(
      (a) => moment(a.start).format("YYYY-MM") == `${yearNow}-${renderMonth}`
    );
    setDataAppointmentsMonthly(dataAppointmentsThisMonth);

    let dataGreetingsThisMonth = initialDataGreetingsMonthly.filter(
      (a) => moment(a.start).format("YYYY-MM") == `${yearNow}-${renderMonth}`
    );
    setDataGreetingsMonthly(dataGreetingsThisMonth);
  }, [
    renderMonth,
    activeNav,
    initialDataAllMonthly,
    initialDataEventsMonthly,
    initialDataAppointmentsMonthly,
    initialDataGreetingsMonthly,
  ]);

  useEffect(() => {
    if (activePage === 0) {
      let filterAll = dataAllMonthly.filter(
        (a) => dateFormat(a.start) === activeDay
      );
      setListAllDataWeekly(filterAll);

      let filterEvents = dataEventsMonthly.filter(
        (a) => dateFormat(a.start) === activeDay
      );
      setListEventsWeekly(filterEvents);

      let filterAppointments = dataAppointmentsMonthly.filter(
        (a) => dateFormat(a.start) === activeDay
      );
      setListAppointmentsWeekly(filterAppointments);

      let filterGreetings = dataGreetingsMonthly.filter(
        (a) => dateFormat(a.start) === activeDay
      );
      setListGreetingsWeekly(filterGreetings);
    }
  }, [activeDay, activePage]);

  return (
    <BaseLayout
      isCustom={true}
      show_menu={false}
      header={
        <HeaderBaseLayout
          src={Assets.iconBackWhite}
          title="Calendar"
          isCustomPicture={true}
          picture={`url(${
            process.env.PUBLIC_URL + "/SKOR-Calendar-Header.png"
          })`}
          onClick={() => navigate(PageRoutes.home)}
        />
      }
    >
      <div className="calendar-wrapper">
        <div className="calendar-header">
          <div className="navbar">
            {dataHeader.map((data, idx) => (
              <div
                key={idx}
                className="list-wrapper"
                onClick={() => setActiveNav(idx)}
              >
                <span
                  className={`nav-list ${
                    idx === activeNav ? "active-list" : ""
                  }`}
                >
                  {data}
                </span>
                <div
                  className={`line ${activeNav === idx ? "active-list" : ""}`}
                />
              </div>
            ))}
            <img
              src={Assets.iconCalendarAddReminder}
              alt="logo_image"
              onClick={handleClickAddReminder}
            />
          </div>
          <div className="range-type">
            <span className="this-month">
              {allMonth[activeMonth]} {yearNow}
            </span>
            <div>
              {btnRange.map((name, idx) => (
                <Button
                  key={idx}
                  className={`btn-range ${
                    activePage === idx ? "btn-range-active" : ""
                  }`}
                  onClick={() => setActivePage(idx)}
                >
                  <span>{name}</span>
                </Button>
              ))}
            </div>
          </div>
        </div>

        {activePage === 1 && <MonthPage {...params} />}
        {activePage === 0 && <WeekPage {...params} />}
      </div>
    </BaseLayout>
  );
};

const mapStateToProps = (state) => ({
  listAll: state.CalendarSM.listAll,
  listEventsWeekly: state.CalendarSM.listEventsWeekly,
  listEventsMonthly: state.CalendarSM.listEventsMonthly,
  listAppointmentsWeekly: state.CalendarSM.listAppointmentsWeekly,
  listAppointmentsMonthly: state.CalendarSM.listAppointmentsMonthly,
  listGreetingsWeekly: state.CalendarSM.listGreetingsWeekly,
  listGreetingsMonthly: state.CalendarSM.listGreetingsMonthly,
});

const mapDispatchToProps = (dispatch) => ({
  getListAll: dispatch.CalendarSM.getListAll,
  getListEventsMonthly: dispatch.CalendarSM.getListEventsMonthly,
  getListEventsWeekly: dispatch.CalendarSM.getListEventsWeekly,
  getListAppointmentsMonthly: dispatch.CalendarSM.getListAppointmentsMonthly,
  getListAppointmentsWeekly: dispatch.CalendarSM.getListAppointmentsWeekly,
  getListGreetingsMonthly: dispatch.CalendarSM.getListGreetingsMonthly,
  getListGreetingsWeekly: dispatch.CalendarSM.getListGreetingsWeekly,
});

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);
